exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram3b4-3 .slots td{padding:0 10px}#diagram3b4-3 .diagram-hint{float:none;position:absolute;top:20px;left:15%;width:auto;padding:0;text-align:left;text-shadow:none;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/3/3b4/diagram3/diagram3.scss
// module id = 1272
// module chunks = 0